export const importRavelin = async () => {
  const module = await import('ravelinjs/core+track+encrypt+promise');
  return module.default;
};
